export const PERMISSION_CODES = {
    MANAGE_REGISTERS: 'MANAGE_REGISTERS',
    RECORD_SALE: 'RECORD_SALE',
    EDIT_CART: 'EDIT_CART',
    MANAGE_SALES: 'MANAGE_SALES',
    FUND_WALLET: 'FUND_WALLET',
    WITHDRAW_TO_CASH: 'WITHDRAW_FROM_WALLET',
    VIEW_COLLECTION_ACCOUNT: 'VIEW_CONNECTED_ACCOUNT',
    CLEAR_CART: 'VOID_CARTS',
    REPRINT_RECEIPT: 'CAN_REPRINT_RECEIPT',
    MANAGE_CUSTOMER: 'MANAGE_CUSTOMER',
    VIEW_REPORT: 'VIEW_REPORT',
    VIEW_SALES: 'VIEW_SALE',
    REFUND_SALE: 'REFUND_SALE',
    RESUME_CART: 'RESUME_CART',
    MANAGE_SALE: 'MANAGE_SALE',
    VIEW_COMPLETED_SALE: 'VIEW_COMPLETED_SALE',
    VIEW_OUTSTANDING_SALE: 'VIEW_OUTSTANDING_SALE',
    VIEW_OWN_OUTSTANDING_SALE: 'VIEW_OWN_OUTSTANDING_SALE',
    VIEW_OWN_COMPLETED_SALE: 'VIEW_OWN_COMPLETED_SALE',
    APPLY_DISCOUNT: 'APPLY_DISCOUNT',
} as const;

export type PermissionCodeTypes =
    (typeof PERMISSION_CODES)[keyof typeof PERMISSION_CODES];
